import { render, staticRenderFns } from "./UserOmsAdd.vue?vue&type=template&id=a90954ea&scoped=true&"
import script from "./UserOmsAdd.vue?vue&type=script&lang=js&"
export * from "./UserOmsAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserOmsAdd.vue?vue&type=style&index=0&id=a90954ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90954ea",
  null
  
)

export default component.exports